export default __webpack_public_path__ + "static/media/Withdraw.2b134342.svg";